import React from 'react';
import styled from "styled-components"
import { NavLink } from "./Header.style";

const Footer = () => {
    return (
        <FooterContainer>
            <FooterContent>
                <h3>Chronofield.fr</h3>
                <p>Explorez le calendrier Erachien et utilisez nos outils pour enrichir votre expérience sur Minefield.fr.</p>
                <p>Ce site n'est en aucun cas lié à l'association Minefield.fr</p>
            </FooterContent>
            <FooterLegal>
                <p>&copy; 2026 Chronofield.fr Tous droits réservés.</p>
                <NavLink to="/cgu">Conditions d'utilisation</NavLink>
            </FooterLegal>
        </FooterContainer>
    );
};

export default Footer;

const FooterContainer = styled.footer`
  background-color: var(--surface-2);
  color: var(--text);
  padding: 20px 20px;
  display: flex;
  height: auto;
  justify-content: space-between;
  align-items: center;
  margin-top: auto;
  flex-wrap: wrap;
  border-top: 1px solid var(--border);

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 16px 8px;
    height: auto;
    gap: 12px;
  }
`;


const FooterContent = styled.div`
  flex: 1;
  padding: 0 20px;

  @media (max-width: 600px) {
    padding: 0;
    width: 100%;
  }
`;

const FooterLegal = styled.div`
  p {
    margin: 0;
  }
  a {
    color: var(--accent);
  }

  @media (max-width: 600px) {
    width: 100%;
    margin-top: 8px;
  }
`;
